import { useAppSelector } from 'hooks';
import { getDataLoadRequests, shouldLoadCache } from 'utils';

import useDataLoad from './useDataLoad';

const useLoadSectionRef = () => {
  const isCached = useAppSelector((state) => shouldLoadCache(state, 'sectionRef'));

  useDataLoad({
    shouldLoad: !isCached,
    requests: getDataLoadRequests().sectionsRef,
    visibilitySettingsCheck: false,
  });
};

export default useLoadSectionRef;
